import axios from 'axios';
import { trimStringForQuery } from 'utils/utils';

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const API_URL = '/api/v1/push-notification/';
const INIT_CALL = 'init';
const END_CALL = 'end';
const INIT_SMS = 'init-sms';
const SEARCH = 'search';
const EXPORT_CSV = 'export-csv';
const DELETE_ALL = 'all';

const searchPushNotifications = async ({ filterQuery, dateRangeFilter, pageIndex, pageSize, sortBy }) => {
	const body = {
		page: pageIndex,
		count: pageSize,
		sortBy: sortBy?.length ? sortBy : [{ id: 'sentAt', desc: true }],
		include: [
			'sentAt',
			'type',
			'phoneNumber',
			'customerPhoneNumber',
			'sentResult',
			'isSent',
		],
		filters: [
			{
				type: 'string',
				name: 'type',
				value: 'MARKETING_NOTIFICATION',
				exactMatch: true,
				negative: true,
			},
			{
				type: 'string',
				name: 'type',
				value: trimStringForQuery(filterQuery),
				exactMatch: false,
				negative: false,
			},
			{
				type: 'string',
				name: 'phoneNumber',
				format: 'phoneNumber',
				value: trimStringForQuery(filterQuery),
				exactMatch: false,
				negative: false,
			},
			{
				type: 'string',
				name: 'customerPhoneNumber',
				format: 'phoneNumber',
				value: trimStringForQuery(filterQuery),
				exactMatch: false,
				negative: false,
			},
		],
	};

	(dateRangeFilter?.from || dateRangeFilter?.to) && body.filters.push({
		type: 'date',
		name: dateRangeFilter?.name,
		from: dateRangeFilter?.from?.toISOString(),
		to: dateRangeFilter?.to?.toISOString(),
	});

	return await axios.post(`${API_URL}${SEARCH}`, body);
};

const getPushNotification = (id) => {
	return axios.get(`${API_URL}/${id}`);
};

const deletePushNotificationsList = async (idsToDelete) => {
	return await axios.delete(`${API_URL}`, {
		data: { idsToDelete }
	});
};

const deleteAllPushNotifications = () => axios.delete(`${API_URL}${DELETE_ALL}`);

const initCallPushNotification = async (data) => {
	return axios.post(`${API_URL}${INIT_CALL}`, {
		...data
	});
};

const endCallPushNotification = async (data) => {
	return axios.post(`${API_URL}${END_CALL}`, {
		...data
	});
};

const initSmsPushNotification = async (data) => {
	return axios.post(`${API_URL}${INIT_SMS}`, {
		...data
	});
};

const downloadPushNotificationsCsvLogs = () => {
	return axios.get(`${API_URL}${EXPORT_CSV}`, { params: { timeZone } });
};

export {
	getPushNotification,
	searchPushNotifications,
	deletePushNotificationsList,
	deleteAllPushNotifications,
	initCallPushNotification,
	endCallPushNotification,
	initSmsPushNotification,
	downloadPushNotificationsCsvLogs,
};
